/** @format */

import {
  faFaceAngry,
  faFaceMeh,
  faFaceSmile,
} from '@fortawesome/pro-solid-svg-icons';

export const PLANNING_SMILEY_ORDER = ['content', 'neutral', 'unhappy'];

export const PLANNING_SMILEY_META = {
  content: {
    iconName: 'face-smile',
    color: 'primary',
    name: 'Content',
  },
  neutral: {
    iconName: 'face-meh',
    color: 'gray',
    name: 'Neutre',
  },
  unhappy: {
    iconName: 'face-angry',
    color: 'error',
    name: 'Pas content',
  },
};

const PLANNING_SMILEY_ICONS = {
  'face-smile': faFaceSmile,
  'face-meh': faFaceMeh,
  'face-angry': faFaceAngry,
};

export function normalizePlanningSmileyMeta(apiMeta, value = 'neutral') {
  if (apiMeta && typeof apiMeta === 'object') {
    return {
      iconName: apiMeta.icon_name || apiMeta.iconName || 'face-meh',
      color: apiMeta.color || 'gray',
      name: apiMeta.name || PLANNING_SMILEY_META.neutral.name,
    };
  }
  return PLANNING_SMILEY_META[value] || PLANNING_SMILEY_META.neutral;
}

export function planningSmileyFromProject(project) {
  if (!project) return 'neutral';
  return project.planningSmiley || project.planning_smiley || 'neutral';
}

export function planningSmileyMetaFromProject(project) {
  if (!project) return PLANNING_SMILEY_META.neutral;
  return normalizePlanningSmileyMeta(
    project.planningSmileyMeta || project.planning_smiley_meta,
    planningSmileyFromProject(project),
  );
}

/** Minimal chantier fields from a planning-smiley PATCH response. */
export function planningSmileyPatchFromApi(data, fallbackValue = 'neutral') {
  const planningSmiley =
    data?.planning_smiley ?? data?.planningSmiley ?? fallbackValue;
  const planningSmileyMeta = normalizePlanningSmileyMeta(
    data?.planning_smiley_meta ?? data?.planningSmileyMeta,
    planningSmiley,
  );
  return {
    planningSmiley,
    planning_smiley: planningSmiley,
    planningSmileyMeta,
    planning_smiley_meta: {
      icon_name: planningSmileyMeta.iconName,
      color: planningSmileyMeta.color,
      name: planningSmileyMeta.name,
    },
  };
}

export function nextPlanningSmiley(current) {
  const value = current || 'neutral';
  const index = PLANNING_SMILEY_ORDER.indexOf(value);
  const baseIndex =
    index >= 0 ? index : PLANNING_SMILEY_ORDER.indexOf('neutral');
  return PLANNING_SMILEY_ORDER[(baseIndex + 1) % PLANNING_SMILEY_ORDER.length];
}

export function planningSmileyIcon(meta) {
  const iconName = meta?.iconName || meta?.icon_name || 'face-meh';
  return PLANNING_SMILEY_ICONS[iconName] || faFaceMeh;
}

export function planningSmileyColorSx(color) {
  if (color === 'primary') return 'primary.main';
  if (color === 'error') return 'error.main';
  return 'text.secondary';
}
